<template>
  <div
    class="surverys-tab-survey-card card waves-effect hoverable"
    :ref="dataSurvey.key"
    @click="$_goTo()"
  >
    <div class="card-content">
      <div class="card-image">
        <img :src="dataSurvey.thumbnail" alt="" />
      </div>
      <div class="card-title center">
        {{ dataSurvey.title }}
      </div>
    </div>
    <div class="progress-wrapper">
      <div class="progress-pusher">
        <div
          class="description center"
          v-if="dataSurvey.key === 'water-hazard'"
        >
          {{ progressBar }}
        </div>
        <div class="description center" v-else>
          {{ surveyStatus ? surveyStatus : progressBar }}
        </div>

        <div
          class="c-progress-bar-wrapper"
          v-if="dataSurvey.key === 'wind-hazard'"
        >
          <div class="c-progress-percent" v-if="surveyStatus">
            {{ surveyStatus }}
          </div>
          <div class="c-progress-percent" v-else>
            {{
              windHazardProgressX
                ? `${windHazardProgressX}%`
                : "Not Yet Started"
            }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${windHazardProgressX}%` }"
            ></div>
          </div>
        </div>

        <div
          class="c-progress-bar-wrapper"
          v-else-if="dataSurvey.key === 'flood-hazard'"
        >
          <div class="c-progress-percent" v-if="surveyStatus">
            {{ surveyStatus }}
          </div>
          <div class="c-progress-percent" v-else>
            {{
              floodHazardProgressX
                ? `${floodHazardProgressX}%`
                : "Not Yet Started"
            }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${floodHazardProgressX}%` }"
            ></div>
          </div>
        </div>

        <div
          class="c-progress-bar-wrapper"
          v-else-if="dataSurvey.key === 'assessment-summary'"
        >
          <div class="c-progress-percent">
            {{
              assessmentProgressX
                ? `${assessmentProgressX}%`
                : "Not Yet Started"
            }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${assessmentProgressX}%` }"
            ></div>
          </div>
        </div>

        <div
          class="c-progress-bar-wrapper"
          v-else-if="dataSurvey.key === 'water-hazard'"
        >
          <div class="c-progress-percent">
            {{
              waterHazardProgressX
                ? `${waterHazardProgressX}%`
                : "Not Yet Started"
            }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${waterHazardProgressX}%` }"
            ></div>
          </div>
        </div>

        <div
          class="c-progress-bar-wrapper"
          v-else-if="dataSurvey.key === 'home-profile'"
        >
          <div class="c-progress-percent">
            {{
              homeProfileProgressX
                ? `${homeProfileProgressX}%`
                : "Not Yet Started"
            }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${homeProfileProgressX}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { schema as floodSchema } from "@/schemas/floodHazard";
import { schema as windSchema } from "@/schemas/windHazard";

const isElementInView = (elChild, elParent) => {
  const elChildRect = elChild.getBoundingClientRect();
  const isInView =
    elChildRect.left >= 0 && elChildRect.right <= elParent.clientWidth;

  return isInView;
};

export default {
  name: "SurveysTabSurveyCard",
  props: {
    dataSurvey: {
      type: Object,
      default: () => ({}),
    },
    dataUserSurveys: {
      type: [Array, Object],
    },
    dataPerformViewCheck: {
      type: Boolean,
      default: false,
    },
    dataCurrentUser: {
      type: Object,
    },
  },
  data() {
    return {
      parentEl: null,
      surveyStatus: "",
    };
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_DIALOG");
  },

  computed: {
    floodHazard() {
      const survey = this.dataUserSurveys.find((x) => x.tags[0] === 39);

      if (survey) return JSON.parse(survey.acf.survey_data);

      return false;
    },
    windHazard() {
      const survey = this.dataUserSurveys.find((x) => x.tags[0] === 38);

      if (survey) return JSON.parse(survey.acf.survey_data);

      return false;
    },
    waterHazard() {
      const survey = this.dataUserSurveys.find((x) => x.tags[0] === 40);

      if (survey) return JSON.parse(survey.acf.survey_data);

      return false;
    },
    user() {
      return { ...this.dataCurrentUser.acf };
    },
    homeProfileProgressX: {
      get() {
        const typeValCheck = (x) => {
          let condition_1 =
            (x && Array.isArray(x) && x.length > 0) ||
            (x && !Array.isArray(x) & (x !== "") && x !== null)
              ? true
              : false;
          let condition_2 =
            !condition_1 && x !== "" && x !== null ? true : false;

          return condition_1;
        };
        let hp =
          this.user.home_profile !== "" && this.user.home_profile
            ? JSON.parse(this.user.home_profile)
            : false;
        return hp
          ? (
              (Object.values(hp).filter((x) => typeValCheck(x)).length /
                Object.values(hp).length) *
              100
            ).toFixed(0)
          : 0;
      },
    },
    windHazardProgressX() {
      if (this.windHazard && this.windHazard.survey !== "") {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(windSchema).filter(
          (key) => windSchema[key].fieldType === "complete_field"
        );

        const currentLen = completeFieldKeyArray.filter(
          (key) => this.windHazard.survey[key]
        ).length;

        const answerLen = Object.values(this.windHazard.survey).filter(
          (item) => {
            if (typeof item === "object") {
              if (item.length > 0) {
                return item;
              }
            } else {
              return item;
            }
          }
        ).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }
      return 0;
    },
    floodHazardProgressX() {
      if (this.floodHazard) {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(floodSchema).filter(
          (key) => floodSchema[key].fieldType === "complete_field"
        );

        const currentLen = completeFieldKeyArray.filter(
          (key) => this.floodHazard.survey[key]
        ).length;

        const answerLen = Object.values(this.floodHazard.survey).filter(
          (item) => {
            if (typeof item === "object") {
              if (item.length > 0) {
                return item;
              }
            } else {
              return item;
            }
          }
        ).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }

      return 0;
    },
    assessmentProgressX: {
      get() {
        const allArr = [
          { ...this.floodHazard },
          { ...this.windHazard },
          { ...this.waterHazard },
        ];
        const k =
          allArr.map((x) => x.assessment).filter((y) => y && y.content).length *
          (100 / allArr.length).toFixed(0);
        return k > 99 ? 100 : k;
      },
    },
    waterHazardProgressX() {
      if (this.waterHazard) {
        const len = 2;

        const currentLen = Object.keys(this.waterHazard.survey).filter(
          (key) => {
            if (key === "water_resiliency_complete") {
              return this.waterHazard.survey[key]; //this.waterHazard.survey[key].length > 0 ? true : false;
            } else if (
              this.waterHazard.isNonStandard &&
              key === "manualEssential"
            ) {
              return (
                this.waterHazard.survey[key].subTotal &&
                parseFloat(this.waterHazard.survey[key].subTotal) > 1
              );
            } else if (!this.waterHazard.isNonStandard && key === "essential") {
              return (
                this.waterHazard.survey[key].subTotal &&
                parseFloat(this.waterHazard.survey[key].subTotal) > 1
              );
            } else {
              return false;
            }
          }
        ).length;
        return Math.round((currentLen / len) * 100);
      }

      return 0;
    },
    progressBar: {
      get() {
        return this.dataSurvey.key === "wind_hazard" && this.windHazardProgressX
          ? `${this.windHazardProgressX}% Completed`
          : this.dataSurvey.key === "assessment_summary" &&
            this.assessmentProgressX
          ? `${this.assessmentProgressX}% Completed`
          : this.dataSurvey.key === "flood_hazard" && this.floodHazardProgressX
          ? `${this.floodHazardProgressX}% Completed`
          : this.dataSurvey.key === "home_profile" && this.homeProfileProgressX
          ? `${this.homeProfileProgressX}% Completed`
          : this.dataSurvey.key === "water_hazard" && this.waterHazardProgressX
          ? `${this.waterHazardProgressX}% Completed`
          : "Not Yet Started";
      },
    },
  },
  methods: {
    $_goTo() {
      this.$router.push({
        name: "surveyReview",
        params: {
          slug: this.dataSurvey.key,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.surverys-tab-survey-card {
  /*   flex-shrink: 0;
  border-radius: 5px;
  width: 200px;
  padding: 1rem;
  margin-right: 25px; */
  /*
  .image-wrapper {
    width: 100%;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  } */

  /*   .title {
    text-transform: uppercase;
    color: #545454;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  } */
  &.card {
    height: calc(100% - 1.5rem);
    border-radius: 10px;
    /* 	overflow: hidden; */
    .card-image {
      height: 140px;
      @media screen and (min-width: 1024px) {
        height: 140px;
      }
      width: 100%;
      text-align: center;
      img {
        height: 100%;
        width: auto;
        display: inline-block;
      }
    }
    .card-content {
      padding: 16px 16px 0;
      .card-title {
        font-size: 15.5px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 0px;
        cursor: pointer;
        text-transform: uppercase;
      }
    }
    .action-wrapper {
      height: 20px;
      width: 100%;
      .card-action {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    // .card-action {
    //   padding: 0px;
    //   border-radius: 0px 0px 5px 5px;
    //   display: flex;
    //   justify-content: space-between;
    //   button {
    //     border: 1px solid rgba(0, 0, 0, 0.1);
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //   }
    // }
  }
  .description {
    font-size: 12px;
  }

  .c-progress-bar-wrapper {
    margin-top: 0px;
    .c-progress-percent {
      font-size: 9px;
      color: #9c9c9c;
    }
    .c-progress-bar {
      position: relative;
      border-radius: 5px;
      width: 100%;
      height: 9px;
      background: #e4e4e4;
      overflow: hidden;
    }
    .c-progress {
      background: #5374f8;
      height: 100%;
    }
  }
  .progress-wrapper {
    padding: 0 16px 16px;
    height: 84px;
    .progress-pusher {
      position: absolute;
      width: calc(100% - 32px);
      bottom: 30px;
    }
  }
}
</style>
